import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../core/hooks';
import {
  fixEmailSelector,
  passwordRecoveryEmailSelector,
  codeResentSelector,
  passwordRecoveryCodeSelector,
  setCodeResent,
  setPasswordRecoveryCode,
  setPasswordRecoveryEmail,
} from '../../features/auth';
import { setFixEmail } from '@src/features/auth';
import { setStepCheckout } from '@src/features/checkout';
import PasswordReset from './PasswordReset';
import ValidCode from './ValidCode';
import PasswordRecovery from './PasswordRecovery';
import { useWidgetId } from '../../core/IdProvider';
import { track } from '@src/services/analytics';

export const PASSWORD_RESET = 'password_reset';
export const VALID_CODE = 'valid_code';
export const PASSWORD_RECOVER = 'password_recover';

interface ForgotPasswordProps {
  onBack: () => void;
}

const ForgotPassword = ({ onBack }: ForgotPasswordProps) => {
  const id = useWidgetId();
  const dispatch = useAppDispatch();
  const fixEmail = useAppSelector(fixEmailSelector);
  const codeResent = useAppSelector(codeResentSelector);
  const passwordRecoveryEmail = useAppSelector(passwordRecoveryEmailSelector);
  const passwordRecoveryCode = useAppSelector(passwordRecoveryCodeSelector);
  const [modeForgot, setModeForgot] = useState(PASSWORD_RESET);

  useEffect(() => {
    dispatch(setStepCheckout({ id, value: '' }));
  });

  useEffect(() => {
    track('recoveryPasswordStarted');
  }, []);

  useEffect(() => {
    if (codeResent) {
      setModeForgot(VALID_CODE);
    }

    if (fixEmail || !passwordRecoveryEmail) {
      setModeForgot(PASSWORD_RESET);
      dispatch(setFixEmail(false));
    }

    if (passwordRecoveryEmail && modeForgot === PASSWORD_RESET) {
      setModeForgot(VALID_CODE);
    }

    if (passwordRecoveryCode && modeForgot === VALID_CODE) {
      setModeForgot(PASSWORD_RECOVER);
      dispatch(setCodeResent(false));
    }
  }, [passwordRecoveryEmail, passwordRecoveryCode, modeForgot]);

  const handleClickOnBack = () => {
    dispatch(setPasswordRecoveryCode(undefined));
    dispatch(setPasswordRecoveryEmail(undefined));
    onBack();

    track('recoveryPasswordBackClick');
  };

  return (
    <div>
      <div>
        {(() => {
          switch (modeForgot) {
            case PASSWORD_RESET:
              return <PasswordReset onBack={handleClickOnBack} />;
            case VALID_CODE:
              return <ValidCode onBack={handleClickOnBack} />;
            case PASSWORD_RECOVER:
              return <PasswordRecovery onBack={handleClickOnBack} />;
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};

export default ForgotPassword;
